import styled from 'styled-components'

export const CellContainer = styled.div<{ $maxWidth?: number }>`
  max-width: ${({ $maxWidth }) => $maxWidth || 220}px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  width: 100%;
`
